import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { useProjectsByUser } from "../../core/utils/hooks/useUsers";
import { NewAssistanceModalConfirm } from "../../components/NewAssistanceModalConfirm";

export const AssistanceRecordContainer = ({ selectedsUsers, handleCloseModal }) => {
  const [openNewAssistance, setOpenNewAssistance] = useState(false)
  const navigate = useNavigate()
  const { projectsByUser } = useProjectsByUser(selectedsUsers[0]?.id)

  const { register, getValues, watch, setValue } = useForm({
    mode: "onChange",
  })

  useEffect(() => {
    if (selectedsUsers?.length > 0) {
      setOpenNewAssistance(true)
    }
  }, [selectedsUsers])

  const handleOpenAssistance = () => {
    setOpenNewAssistance((prev) => !prev)
    handleCloseModal(false)
    setValue("assistanceTitle", "")
  }

  const handleNewAssitanceConfirm = () => {
    setOpenNewAssistance(false)
    navigate(`/farmer/profile/${selectedsUsers[0]?.id}?context=false&category=new&origin=fromUsers`, {
      state: { fromUsers: { ...selectedsUsers[0], projectsByUser, assistanceTitle: getValues()?.assistanceTitle } },
    })
    setValue("assistanceTitle", "")
  }

  return (
    <>
      <NewAssistanceModalConfirm
        {...{
          openNewAssistance,
          handleOpenAssistance,
          handleNewAssitanceConfirm,
          register,
          watch
        }}
      />
    </>
  )
}